import { createSlice } from '@reduxjs/toolkit';
import { getIntervals } from 'ducks/intervals-list/operators';
import { Slices } from 'ducks/slices';
import { normalizeLookups } from 'ducks/utils';

export type IntervalsListState = ReturnType<typeof normalizeLookups<'interval_name', 'interval_id'>>;
const initialState: IntervalsListState = [];

const intervalsListSlice = createSlice({
  name: Slices.INTERVALS_LIST,
  initialState,
  reducers: {
    clearIntervalsList: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getIntervals.pending, () => {
        return initialState;
      })
      .addCase(getIntervals.fulfilled, (_, { payload }) => {
        return normalizeLookups(payload, 'interval_name', 'interval_id');
      })
      .addCase(getIntervals.rejected, () => {
        return initialState;
      });
  },
});

export const { clearIntervalsList } = intervalsListSlice.actions;

export default intervalsListSlice.reducer;
